import { IStepComponent } from '../types';
import { AttachmentButtonContainer, Title } from './styled';
import AttachmentButton from '../../components/AttachmentButton';
import { en } from '../../../i18n';
import useStep from './useStep';
import { EApplyTypes } from '../../types';

const { apply } = en;

const SubmitScreen = ({ question }: IStepComponent) => {
  const { renderSanitizedText, onUpload, currentResponse, currentType } = useStep({ question });

  const text = currentType === EApplyTypes.JOB_APP ? en.apply.submit.titleBJobApp : en.apply.submit.titleB;

  return (
    <>
      <Title centerMobile>{en.apply.submit.titleA}</Title>
      <Title centerMobile>{renderSanitizedText(text, true)}</Title>
      <AttachmentButtonContainer>
        <AttachmentButton
          text={apply.uploadResume.buttonText}
          onUpload={onUpload}
          externalFile={currentResponse as File}
        />
      </AttachmentButtonContainer>
    </>
  );
};

export default SubmitScreen;
